<qai-toast [ariaLabel]="'results.KC_TOAST_TITLE' | transloco" />
<div class="floating-banners">
  <simulation-generation-banner-host />
  <call-refinement-banner-host />
</div>
<router-outlet></router-outlet>
